/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable, computed} from 'mobx';
import Location from "../Location";

export default class FlightRoutePoint {
  @observable gps_lat: number;
  @observable gps_long: number;
  @observable location_id: string;
  @observable name: string;

  constructor(json?: any) {
    if(json) {
      this.gps_lat = json.gps_lat || null;
      this.gps_long = json.gps_long || null;
      this.location_id = json.location_id || null;
      this.name = json.name || null;
    }
  }

  fromLatLng(latLng) {
    this.gps_lat = typeof latLng.lat === "function" ? latLng.lat() : latLng.lat;
    this.gps_long = typeof latLng.lng === "function" ? latLng.lng() : latLng.lng;
    this.location_id = null;
  }

  fromLocation(location: Location) {
    this.fromLatLng(location.latLng);
    this.location_id = location.id;
    this.name = location.name;
  }

  @computed get latLng(): Object {
    return {
      lat: +this.gps_lat,
      lng: +this.gps_long
    }
  }

  @computed get title(): string {
    return this.name || (this.gps_lat.toFixed(6) + ', ' + this.gps_long.toFixed(6));
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Flight/FlightRoutePoint.js